export type { Foundation } from './foundation';

export { default as dark } from './theme/dark';
export { default as light } from './theme/light';
